import { Component } from '@angular/core';
import { ActivityStatsComponent } from './activity-stats.component';

@Component({
  selector: 'eid-activity-stats-desktop',
  templateUrl: './activity-stats.desktop.component.html',
  styleUrls: ['./activity-stats.desktop.component.scss']
})
export class ActivityStatsDesktopComponent extends ActivityStatsComponent {}
